import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react'
import {
  Table,
  Button,
  InputNumber,
  Input,
  Divider,
  Space,
  Typography,
  Statistic,
  Modal,
  Radio,
  Card,
  Tag,
} from 'antd'
import {
  PlusOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  MinusOutlined,
  LoadingOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  ThunderboltOutlined,
  FireOutlined,
  PrinterOutlined,
  InboxOutlined,
} from '@ant-design/icons'
import './BillPanelNoContext.css'
import { generateBillPdf } from './billPdfGenerator'
import { getPdfConfigAPI } from '../../../api/pdfApi'
import BillService from '../../services/Billservice'
import { notify } from '../../components/Customs/NotifyProvider'
import {
  DrinkBillSection,
  DrinkPickerModal,
  useDrinkItems,
  isDrinkBillRow,
} from './Drinksection'

const { Text } = Typography

const findExisting = (items, menuItemId, isParcel = 0) =>
  items.find(
    (i) =>
      String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
      Number(i.is_parcel || 0) === Number(isParcel || 0)
  )

const getItemsSignature = (items = []) =>
  JSON.stringify(
    items.map((i) => ({
      menu_item_id: i.menu_item_id ?? i.menuItemId,
      qty: Number(i.qty || 0),
      price: Number(i.price || 0),
      is_parcel: Number(i.is_parcel || 0),
    }))
  )

const toFoodPayload = (items) =>
  items.map((i) => ({
    menu_item_id: i.menu_item_id ?? i.menuItemId,
    name: i.name,
    price: i.price,
    qty: i.qty,
    is_parcel: Number(i.is_parcel || 0),
    is_drink: 0,
  }))

const toDrinkPayload = (drinkItems, isAcTable) =>
  drinkItems.map((i) => ({
    menu_item_id: i.menu_item_id,
    name: i.name,
    price: 0,
    qty: 1,
    is_parcel: 0,
    is_drink: 1,
    pegs: i.pegs || [],
    peg_qtys: i.peg_qtys || {},
    bottle_qty: i.bottle_qty || 0,
    price_bottle: isAcTable
        ? (i.ac_price ?? i.price_bottle ?? 0)
        : (i.price_bottle ?? 0),
    cgst_pct: i.cgst_pct || 0,
    sgst_pct: i.sgst_pct || 0,
  }))

const ProductCard = ({
  item,
  isAcTable,
  isDrink = false,   //  add this
  existingItem,
  onAdd,
  onIncrease,
  onDecrease,
  canEditItems,
  modeLabel,
}) => {
  console.log("MENU ITEM**ooooooooooooooooooooooooooooo***:", item)

  return (
    <div
      className={`be-product-card ${existingItem ? 'already-added' : ''} ${!canEditItems ? 'disabled' : ''}`}
      onClick={() => canEditItems && onAdd(item)}
      title={
        !canEditItems
          ? 'View only'
          : existingItem
          ? 'Click to add more · − to reduce'
          : `Click to add${modeLabel ? ` as ${modeLabel}` : ''}`
      }
      style={!canEditItems ? { opacity: 0.7, cursor: 'not-allowed' } : undefined}
    >
      <div
        className="be-product-dot"
        style={{
          background: (item.is_veg ?? item.veg) ? '#22c55e' : '#ef4444',
        }}
      />

      <div className="be-product-card-body">
        <span className="be-product-card-name">{item.name}</span>

       <span className="be-product-card-price">
            ₹{
              isDrink
                ? (isAcTable
                    ? Number(item.ac_price ?? "xxxx" ?? 0)
                    : Number(item.price_bottle ?? 0))
                : (isAcTable
                    ? Number(item.ac_price ?? item.price)
                    : Number(item.price))
            }
          </span>
      </div>

      {existingItem && (
        <div
          className="be-product-qty-controls"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="be-qty-btn be-minus-btn"
            onClick={() =>
              canEditItems &&
              onDecrease(item.id ?? item.menu_item_id)
            }
            disabled={!canEditItems}
            type="button"
          >
            <MinusOutlined style={{ fontSize: 9 }} />
          </button>

          <span className="be-qty-value">{existingItem.qty}</span>

          <button
            className="be-qty-btn be-plus-btn"
            onClick={() =>
              canEditItems &&
              onIncrease(item.id ?? item.menu_item_id)
            }
            disabled={!canEditItems}
            type="button"
          >
            <PlusOutlined style={{ fontSize: 9 }} />
          </button>
        </div>
      )}
    </div>
  )
}


const ProductPickerModal = ({
  open,
  onClose,
  onAdd,
  onIncrease,
  onDecrease,
  existingItems,
  menuItems = [],
  categories = [],
  canEditItems = false,
  title = 'Add Products to Bill',
  modeLabel = '',
   isAcTable,
}) => {
  const [search, setSearch] = useState('')
  const [category, setCategory] = useState('All')

  const categoryNames = React.useMemo(() => {
    const names = categories.map((c) => c.name)
    return ['All', ...names]
  }, [categories])

  const filtered = React.useMemo(
    () =>
      menuItems.filter((m) => {
        const itemCategory = m.category ?? m.category_name ?? m.categoryName ?? ''
        const matchCat = category === 'All' || itemCategory === category
        const matchSearch = String(m.name || '').toLowerCase().includes(search.toLowerCase())
        const isActive = m.is_active !== 0 && m.is_active !== false
        return matchCat && matchSearch && isActive
      }),
    [menuItems, search, category]
  )

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={760}
      className="be-product-picker-modal"
    >
      <Space direction="vertical" style={{ width: '100%' }} size={14}>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search items..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
          size="large"
          disabled={!canEditItems}
        />

        <div className="be-category-scroll">
          {categoryNames.map((c) => (
            <button
              key={c}
              className={`be-cat-chip ${category === c ? 'active' : ''}`}
              onClick={() => canEditItems && setCategory(c)}
              type="button"
              disabled={!canEditItems}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="be-picker-topnote">
          {canEditItems
            ? `Click item to add quickly${modeLabel ? ` as ${modeLabel}` : ''}. Use plus/minus for instant quantity update.`
            : 'View only mode.'}
        </div>

        <div className="be-product-grid">
          {filtered.length === 0 && <p className="be-no-items">No items found</p>}
          {filtered.map((item) => {
            const existingItem = findExisting(
              existingItems,
              item.id,
              modeLabel === 'parcel' ? 1 : 0
            )
            return (
              <ProductCard
                key={item.id}
                item={item}
                existingItem={existingItem}
                onAdd={onAdd}
                onIncrease={onIncrease}
                onDecrease={onDecrease}
                canEditItems={canEditItems}
                modeLabel={modeLabel}
                isAcTable={isAcTable}
                  
              />
            )
          })}
        </div>
      </Space>
    </Modal>
  )
}

const SettleModal = ({ open, onClose, onSettle, total, billSummary }) => {
  const [method, setMethod] = useState('Cash')
  const [saving, setSaving] = useState(false)

  const handleOk = async () => {
    setSaving(true)
    try {
      await onSettle(method, billSummary)
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      title="Settle Bill"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={saving ? 'Processing…' : 'Confirm Payment'}
      okButtonProps={{ type: 'primary', loading: saving }}
    >
      <Space direction="vertical" style={{ width: '100%' }} size={16}>
        <Statistic title="Amount to Collect" value={Math.round(total)} prefix="₹" precision={2} />
        <div>
          <Text strong>Payment Method</Text>
          <Radio.Group
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}
          >
            {['Cash', 'UPI', 'Card', 'Wallet'].map((m) => (
              <Radio.Button key={m} value={m}>{m}</Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </Space>
    </Modal>
  )
}

const BillEditorNoContext = ({
  bill,
  tableId,
  table,
  onSplit,
  updateBillItems,
  updateBillMeta,
  closeBill,
  menuItems = [],
  categories = [],
  generalSettings = {},
}) => {
  const canEditItems = typeof updateBillItems === 'function'
  const canEditMeta = typeof updateBillMeta === 'function'
  const canCloseBill = typeof closeBill === 'function'
  const canSplitBill = typeof onSplit === 'function'


  const isAcTable = useMemo(
  () => String(table?.ac_type || '').toUpperCase() === 'AC',
  [table]
)

  // Room Service orders are parcel-only (guests aren't dining in at a
  // table) — "Add Food Items" is still needed for regular dine-in table
  // billing, so this only hides it for room_service bills, not globally.
  const isRoomServiceBill = bill?.source === 'room_service'

  const [pickerOpen, setPickerOpen] = useState(false)
  const [parcelPickerOpen, setParcelPickerOpen] = useState(false)
  const [drinkPickerOpen, setDrinkPickerOpen] = useState(false)
  const [settleOpen, setSettleOpen] = useState(false)
  const [syncing, setSyncing] = useState(false)
  const [printingKitchen, setPrintingKitchen] = useState(false)
  const [printingBill, setPrintingBill] = useState(false)
  const [printingDrinkKitchen, setPrintingDrinkKitchen] = useState(false)

  const [localItems, setLocalItems] = useState(
    Array.isArray(bill.items) ? bill.items.filter((i) => Number(i.is_drink || 0) === 0) : []
  )
  const [localDiscount, setLocalDiscount] = useState(Number(bill.discount) || 0)
  const [localNote, setLocalNote] = useState(bill.note || '')

  const localItemsRef = useRef(localItems)
  const prevBillIdRef = useRef(null)
  const savingRef = useRef(false)
  const queuedSaveRef = useRef(null)

  const {
    drinkItems,
    setDrinkItems,
    addDrinkItem,
    changeDrinkPeg,
    changeDrinkBottle,
    removeDrinkItem,
    drinkSubtotal,
    drinkCgst,
    drinkSgst,
  } = useDrinkItems()

  const hydratedDrinkRef = useRef(false)
  const isHydratingRef = useRef(false)

  //  FIXED: Declare these BEFORE using them in drinkTotal
  const getSettingNumber = useCallback(
    (key) => Number(generalSettings?.[key] || 0),
    [generalSettings]
  )

  const cgstTax = getSettingNumber('cgst_tax')
  const sgstTax = getSettingNumber('sgst_tax')

  const drinkCgstPct = getSettingNumber('drink_cgst_tax')
  const drinkSgstPct = getSettingNumber('drink_sgst_tax')
  const drinkVatPct = getSettingNumber('drink_vat')

  const drinkCgstAmount = useMemo(
    () => Number(drinkCgst || 0),
    [drinkCgst]
  )

  const drinkSgstAmount = useMemo(
    () => Number(drinkSgst || 0),
    [drinkSgst]
  )
  
  const drinkVatAmount = useMemo(
    () => (drinkSubtotal * drinkVatPct) / 100,
    [drinkSubtotal, drinkVatPct]
  )

  //  NOW drinkCgstAmount and drinkSgstAmount are declared, so this works
  const drinkTotal = useMemo(
    () => drinkSubtotal + drinkCgstAmount + drinkSgstAmount + drinkVatAmount,
    [drinkSubtotal, drinkCgstAmount, drinkSgstAmount, drinkVatAmount]
  )


  //debug
useEffect(() => {
  console.log("🔥 BILL ITEMS FROM API:", bill.items)
}, [bill.items])




  useEffect(() => {
    if (prevBillIdRef.current !== bill.id) {
      hydratedDrinkRef.current = false
    }
  }, [bill.id])






  useEffect(() => {
  if (!bill.id || hydratedDrinkRef.current) return

  isHydratingRef.current = true

  const incomingItems = Array.isArray(bill.items) ? bill.items : []

  const drinkItemsFromAPI = incomingItems.filter(
    (i) => Number(i.is_drink || 0) === 1
  )

  const drinkItemsConverted = drinkItemsFromAPI.map((item) => {
  const details =
    typeof item.drink_details === 'string'
      ? JSON.parse(item.drink_details || '{}')
      : item.drink_details || {}

  const acPrice = Number(item.ac_price ?? details.ac_price ?? 0)
  const normalPrice = Number(
    details.price_bottle ??
    item.price_bottle ??
    item.price ??
    details.sell_price ??
    0
  )
  const resolvedBottlePrice = isAcTable
    ? (acPrice > 0 ? acPrice : normalPrice)
    : normalPrice

  return {
    menu_item_id: item.menu_item_id,
    name: item.name,

    //  final bottle price logic
    price_bottle: resolvedBottlePrice,

    // keep AC price clean
    ac_price: acPrice,

    pegs: details.pegs || [],
    peg_qtys: details.peg_qtys || {},
    bottle_qty: details.bottle_qty || 0,

    cgst_pct: Number(item.drink_cgst_pct || 0),
    sgst_pct: Number(item.drink_sgst_pct || 0),

    category_name: item.category_name || '',
  }
})
  setDrinkItems(drinkItemsConverted)

  hydratedDrinkRef.current = true

  setTimeout(() => {
    isHydratingRef.current = false
  }, 0)
}, [bill.id, bill.items, isAcTable, setDrinkItems])


  const parcelCharge = getSettingNumber('parcel_charge')
  const additionalCharge = getSettingNumber('additional_charge')
  const acChargeSetting = getSettingNumber('ac_charge')
  const taxType = String(generalSettings?.tax_type || 'percentage').toLowerCase()
  const totalTaxPct = cgstTax + sgstTax

 

  useEffect(() => {
  console.log("TABLE DATA:", table)
  console.log("AC TYPE:", table?.ac_type)
  console.log("IS AC TABLE:", isAcTable)
}, [table, isAcTable])

 
  const parcelItemPrice = useCallback((menuItem) => Number(menuItem.price || 0), [])

  useEffect(() => {
    localItemsRef.current = localItems
  }, [localItems])

  const parcelQty = useMemo(
    () =>
      localItems.reduce(
        (sum, item) =>
          Number(item.is_parcel || 0) === 1 ? sum + (Number(item.qty) || 0) : sum,
        0
      ),
    [localItems]
  )

  const parcelChargeTotal = useMemo(
    () => parcelQty * Number(parcelCharge || 0),
    [parcelQty, parcelCharge]
  )
  const additionalChargeTotal = useMemo(
    () => parcelQty * Number(additionalCharge || 0),
    [parcelQty, additionalCharge]
  )


 

 const acChargeTotal = useMemo(
    () => (isAcTable ? Number(acChargeSetting || 0) : 0),
    [isAcTable, acChargeSetting]
  )


      






  const itemsSubtotal = useMemo(
    () =>
      localItems.reduce(
        (sum, item) => sum + (Number(item.price) || 0) * (Number(item.qty) || 0),
        0
      ),
    [localItems]
  )

  const taxableAmount = useMemo(
    () => itemsSubtotal + parcelChargeTotal + additionalChargeTotal + acChargeTotal,
    [itemsSubtotal, parcelChargeTotal, additionalChargeTotal, acChargeTotal]
  )

  const cgstAmount = useMemo(
    () =>
      localItems.reduce(
        (sum, item) => sum + Number(item.item_cgst_amount || 0),
        0
      ),
    [localItems]
  )

  const sgstAmount = useMemo(
    () =>
      localItems.reduce(
        (sum, item) => sum + Number(item.item_sgst_amount || 0),
        0
      ),
    [localItems]
  )
 

  const totals = useMemo(() => {
    const tax =
      taxType === 'percentage'
        ? cgstAmount + sgstAmount
        : taxableAmount > 0
          ? totalTaxPct
          : 0

    const foodTotal = Math.max(
      0,
      itemsSubtotal + parcelChargeTotal + additionalChargeTotal + acChargeTotal  + tax
    )

    return { subtotal: itemsSubtotal, tax, total: foodTotal }
  }, [
    itemsSubtotal,
    parcelChargeTotal,
    additionalChargeTotal,
    acChargeTotal,
    localDiscount,
    taxType,
    totalTaxPct,
    cgstAmount,
    sgstAmount,
    taxableAmount,
  ])

  const grandTotal = totals.total + drinkTotal-localDiscount


  useEffect(() => {
    const incomingItems = Array.isArray(bill.items) ? bill.items : []
    const incomingDiscount = Number(bill.discount) || 0
    const incomingNote = bill.note || ''

    const billChanged = prevBillIdRef.current !== bill.id
    const incomingSig = getItemsSignature(
      incomingItems.filter((i) => Number(i.is_drink || 0) === 0)
    )
    const localSig = getItemsSignature(localItemsRef.current)

   if (billChanged) {
  prevBillIdRef.current = bill.id

  const foodOnly = incomingItems.filter(
    (i) => Number(i.is_drink || 0) === 0
  )

  // 🔥 APPLY AC PRICE LOGIC HERE
  const updatedItems = foodOnly.map((item) => ({
    ...item,
    price: isAcTable
      ? Number(item.ac_price ?? item.price)
      : Number(item.price),
  }))

  setLocalItems(updatedItems)
  setLocalDiscount(incomingDiscount)
  setLocalNote(incomingNote)
  localItemsRef.current = updatedItems

  return
}
    if (!savingRef.current && !syncing && incomingSig !== localSig) {
  const foodOnly = incomingItems.filter(
    (i) => Number(i.is_drink || 0) === 0
  )

  // 🔥 APPLY AC PRICE HERE
  const updatedItems = foodOnly.map((item) => ({
    ...item,
    price: isAcTable
      ? Number(item.ac_price ?? item.price)
      : Number(item.price),
  }))

  setLocalItems(updatedItems)
  setLocalDiscount(incomingDiscount)
  setLocalNote(incomingNote)
  localItemsRef.current = updatedItems
}
  }, [bill.id, bill.items, bill.discount, bill.note, syncing, isAcTable])


// 🔥 Recalculate prices when AC / Non-AC changes
useEffect(() => {
  setLocalItems((prev) => {
    const updated = prev.map((item) => ({
      ...item,
      price: isAcTable
        ? Number(item.ac_price || item.price)
        : Number(item.price),
    }))

    // keep ref in sync
    localItemsRef.current = updated
    return updated
  })
}, [isAcTable])

   //drink ac price
useEffect(() => {
  setDrinkItems((prev) =>
    prev.map((item) => ({
      ...item,
      price_bottle: isAcTable
        ? (Number(item.ac_price ?? 0) > 0
            ? Number(item.ac_price)
            : Number(item.price_bottle ?? 0))
        : Number(item.price_bottle ?? 0),
    }))
  )
}, [isAcTable, setDrinkItems])






  const saveItems = useCallback(
    async (nextFoodItems, latestDrinkItems) => {
      if (!canEditItems) return

      if (savingRef.current) {
        queuedSaveRef.current = { foodItems: nextFoodItems, drinkItems: latestDrinkItems }
        return
      }

      savingRef.current = true
      setSyncing(true)

      try {
        const payload = [
          ...toFoodPayload(nextFoodItems),
          ...toDrinkPayload(latestDrinkItems),
        ]

        const updatedBill = await updateBillItems(tableId, bill.id, payload)

       if (updatedBill?.items) {
              const foodOnly = updatedBill.items.filter((i) => Number(i.is_drink || 0) === 0)

              const updatedItems = foodOnly.map((item) => ({
                ...item,
                price: isAcTable
                  ? Number(item.ac_price ?? item.price)
                  : Number(item.price),
              }))

              setLocalItems(updatedItems)
              localItemsRef.current = updatedItems
            }
        if (updatedBill?.discount !== undefined) {
          setLocalDiscount(Number(updatedBill.discount) || 0)
        }
        if (updatedBill?.note !== undefined) {
          setLocalNote(updatedBill.note || '')
        }
      } catch (error) {
        console.error('Failed to save items:', error)
      } finally {
        savingRef.current = false

        if (queuedSaveRef.current) {
          const { foodItems, drinkItems: qDrink } = queuedSaveRef.current
          queuedSaveRef.current = null
          await saveItems(foodItems, qDrink)
          return
        }

        setSyncing(false)
      }
    },
    [tableId, bill.id, updateBillItems, canEditItems]
  )

  const applyChange = useCallback(
    (updater) => {
      if (!canEditItems) return
      setLocalItems((prev) => {
        const nextItems = typeof updater === 'function' ? updater(prev) : updater
        localItemsRef.current = nextItems
        saveItems(nextItems, drinkItems)
        return nextItems
      })
    },
    [saveItems, canEditItems, drinkItems]
  )

  const drinkItemsInitRef = useRef(false)
  useEffect(() => {
    if (!drinkItemsInitRef.current) {
      drinkItemsInitRef.current = true
      return
    }
    if (isHydratingRef.current) {
      return
    }
    if (canEditItems) {
      saveItems(localItemsRef.current, drinkItems)
    }
  }, [drinkItems, canEditItems, saveItems])

  const getItemKey = useCallback((item) => {
    return item.id || item.tempKey || `temp_${item.menu_item_id || item.menuItemId}`
  }, [])

  const addItem = useCallback(
    (menuItem) => {
      if (!canEditItems) return
      applyChange((prev) => {
        const existing = findExisting(prev, menuItem.id, 0)
        if (existing) {
          return prev.map((i) =>
            String(i.menu_item_id ?? i.menuItemId) === String(menuItem.id) &&
              Number(i.is_parcel || 0) === 0
              ? { ...i, qty: Number(i.qty || 0) + 1, 
                 price: isAcTable
                    ? Number(menuItem.ac_price ?? menuItem.price)
                    : Number(menuItem.price),
               }
              : i
          )
        }
        return [
          ...prev,
          {
            tempKey: `temp_${menuItem.id}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
            menu_item_id: menuItem.id,
            name: menuItem.name,
            price: isAcTable
                ? Number(menuItem.ac_price ?? menuItem.price)
                : Number(menuItem.price),
            qty: 1,
            is_parcel: 0,
            is_drink: 0,
            is_veg: menuItem.is_veg ?? menuItem.veg,
           
          },
        ]
      })
    },
    [applyChange, canEditItems, isAcTable]
  )

  const addParcelItem = useCallback(
    (menuItem) => {
      if (!canEditItems) return
      applyChange((prev) => {
        const existing = findExisting(prev, menuItem.id, 1)
        if (existing) {
          return prev.map((i) =>
            String(i.menu_item_id ?? i.menuItemId) === String(menuItem.id) &&
              Number(i.is_parcel || 0) === 1
              ? { ...i, qty: Number(i.qty || 0) + 1, price: parcelItemPrice(menuItem) }
              : i
          )
        }
        return [
          ...prev,
          {
            tempKey: `parcel_${menuItem.id}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
            menu_item_id: menuItem.id,
            name: menuItem.name,
            price: parcelItemPrice(menuItem),
            qty: 1,
            is_parcel: 1,
            is_drink: 0,
            is_veg: menuItem.is_veg ?? menuItem.veg,
          },
        ]
      })
    },
    [applyChange, canEditItems, parcelItemPrice]
  )

  const increaseByMenuId = useCallback(
    (menuItemId) => {
      if (!canEditItems) return
      applyChange((prev) =>
        prev.map((i) =>
          String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
            Number(i.is_parcel || 0) === 0
            ? { ...i, qty: Number(i.qty || 0) + 1 }
            : i
        )
      )
    },
    [applyChange, canEditItems]
  )

  const decreaseByMenuId = useCallback(
    (menuItemId) => {
      if (!canEditItems) return
      applyChange((prev) => {
        const row = findExisting(prev, menuItemId, 0)
        if (!row) return prev
        if ((Number(row.qty) || 0) <= 1) {
          return prev.filter(
            (i) =>
              !(String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
                Number(i.is_parcel || 0) === 0)
          )
        }
        return prev.map((i) =>
          String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
            Number(i.is_parcel || 0) === 0
            ? { ...i, qty: Number(i.qty || 0) - 1 }
            : i
        )
      })
    },
    [applyChange, canEditItems]
  )

  const increaseParcelByMenuId = useCallback(
    (menuItemId) => {
      if (!canEditItems) return
      applyChange((prev) =>
        prev.map((i) =>
          String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
            Number(i.is_parcel || 0) === 1
            ? { ...i, qty: Number(i.qty || 0) + 1 }
            : i
        )
      )
    },
    [applyChange, canEditItems]
  )

  const decreaseParcelByMenuId = useCallback(
    (menuItemId) => {
      if (!canEditItems) return
      applyChange((prev) => {
        const row = findExisting(prev, menuItemId, 1)
        if (!row) return prev
        if ((Number(row.qty) || 0) <= 1) {
          return prev.filter(
            (i) =>
              !(String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
                Number(i.is_parcel || 0) === 1)
          )
        }
        return prev.map((i) =>
          String(i.menu_item_id ?? i.menuItemId) === String(menuItemId) &&
            Number(i.is_parcel || 0) === 1
            ? { ...i, qty: Number(i.qty || 0) - 1 }
            : i
        )
      })
    },
    [applyChange, canEditItems]
  )

  const updateQtyByRowKey = useCallback(
    (rowKey, newQty) => {
      if (!canEditItems) return
      applyChange((prev) => {
        if (newQty <= 0) return prev.filter((item) => getItemKey(item) !== rowKey)
        return prev.map((item) =>
          getItemKey(item) === rowKey ? { ...item, qty: Number(newQty) || 0 } : item
        )
      })
    },
    [applyChange, getItemKey, canEditItems]
  )

  const removeRow = useCallback(
    (rowKey) => {
      if (!canEditItems) return
      applyChange((prev) => prev.filter((item) => getItemKey(item) !== rowKey))
    },
    [applyChange, getItemKey, canEditItems]
  )

  const saveMeta = useCallback(
    async (field, value) => {
      if (!canEditMeta) return
      if (field === 'discount') {
        const v = Number(value) || 0
        setLocalDiscount(v)
        await updateBillMeta(tableId, bill.id, { discount: v, note: localNote })
      }
      if (field === 'note') {
        setLocalNote(value)
        await updateBillMeta(tableId, bill.id, { discount: localDiscount, note: value })
      }
    },
    [tableId, bill.id, localDiscount, localNote, updateBillMeta, canEditMeta]
  )

  const fetchBillForPrint = useCallback(async () => {
    const freshBill = await BillService.getBillById(bill.id)

    if (!freshBill || !freshBill.id) {
      throw new Error('Failed to fetch latest bill details')
    }

    const freshItems = Array.isArray(freshBill.items) ? freshBill.items : []
    const freshTotals = freshBill.totals || {}

    return {
      bill: freshBill,
      items: freshItems,

      // 🔹 FOOD TOTALS
      discount: Number(freshBill.discount) || 0,
      subtotal: Number(freshTotals.subtotal) || 0,
      tax: Number(freshTotals.tax) || 0,
      total: Number(freshTotals.total) || 0,

      // 🔹 DRINK TOTALS (IMPORTANT FIX)
      drinkSubtotal: Number(freshTotals.drink_subtotal) || 0,
      drinkCgst: Number(freshTotals.drink_cgst) || 0,
      drinkSgst: Number(freshTotals.drink_sgst) || 0,
      drinkTotal: Number(freshTotals.drink_total) || 0,

      note: freshBill.note || '',
      paymentMethod: freshBill.payment_method || 'Cash',
    }
  }, [bill.id])

  const getHotelConfig = useCallback(async () => {
  const config = await getPdfConfigAPI()

  return {
    name: config.hotel_name,
    subtitle: config.subtitle,
    address: config.address,
    phone: config.phone_no || '', 
    gst: config.gst_no,
    vat: config.vat_no,
    fssai: config.fssai_no,
    footerTitle: config.footer_title,
    footerSubtitle: config.footer_subtitle,
    terms: config.terms,
  }
}, [])

  const handlePrintKitchen = useCallback(async () => {
    if (!bill?.id) {
      notify.error('Bill not found')
      return
    }

    setPrintingKitchen(true)
    try {
      const fresh = await fetchBillForPrint()
      const kitchenItems = fresh.items.filter((i) => Number(i.is_drink || 0) === 0)
      const hotel = await getHotelConfig()
      generateBillPdf({
        type: 'kitchen',
        hotel,
        bill: fresh.bill,
        tableId,
        items: kitchenItems,
        note: localNote,
        paymentMode: '',
      })
    } catch (error) {
      console.error('Kitchen print failed:', error)
      notify.error('Print Failed', error?.message || 'Failed to print kitchen order')
    } finally {
      setPrintingKitchen(false)
    }
  }, [bill?.id, fetchBillForPrint, tableId, localNote])

  const handlePrintBill = useCallback(async () => {
    if (!bill?.id) {
      notify.error('Bill not found')
      return
    }

    const fmt = (value) => {
      const num = Number(value || 0)
      return num % 1 === 0 ? String(num) : num.toFixed(2)
    }

    setPrintingBill(true)

    try {
      const fresh = await fetchBillForPrint()

      const printableItems = (fresh.items || []).flatMap((item) => {
        if (Number(item.is_drink || 0) !== 1) {
          return [{
            ...item,
            price: Number(item.price || 0),
            display_price: fmt(item.price),
            display_amount: fmt(Number(item.price || 0) * Number(item.qty || 0)),
          }]
        }

        let details = item.drink_details

        if (typeof details === 'string') {
          try {
            details = JSON.parse(details || '{}')
          } catch {
            details = {}
          }
        }

        details = details || {}

        const rows = []
        const bottleQty = Number(details.bottle_qty || 0)

        if (bottleQty > 0) {
          const price = Number(details.price_bottle || 0)
          rows.push({
            ...item,
            name: `${item.name} Bottle`,
            price,
            qty: bottleQty,
            display_price: fmt(price),
            display_amount: fmt(price * bottleQty),
          })
        }

        Object.entries(details.peg_qtys || {}).forEach(([pegId, qty]) => {
          const pegQty = Number(qty || 0)
          if (pegQty <= 0) return

          const peg = (details.pegs || []).find(
            (p) => String(p.id) === String(pegId)
          )

          const pegMl = peg?.qty || pegId
          const price = isAcTable
            ? Number((peg?.ac_price ?? peg?.price) || 0)
            : Number(peg?.price || 0)

          rows.push({
            ...item,
            name: `${item.name} ${pegMl}ml Peg`,
            price,
            qty: pegQty,
            display_price: fmt(price),
            display_amount: fmt(price * pegQty),
          })
        })

        return rows
      })

      const foodTaxable =
        Number(fresh.subtotal || 0) +
        Number(parcelChargeTotal || 0) +
        Number(additionalChargeTotal || 0) +
        Number(acChargeTotal || 0)

      const foodTax =
        taxType === 'percentage'
          ? foodTaxable * (Number(totalTaxPct || 0) / 100)
          : foodTaxable > 0
            ? Number(totalTaxPct || 0)
            : 0

      const foodTotal =
        foodTaxable - Number(fresh.discount || 0) + foodTax

      const finalTotal =
        foodTotal + drinkTotal
         const hotel = await getHotelConfig()



      generateBillPdf({
        type: 'normal',
        hotel,
        bill: fresh.bill,
        tableId,
        items: printableItems,

        subtotal: Number(fresh.subtotal || 0),
        discount: fresh.discount,
        tax: foodTax,
        total: finalTotal,

        parcelChargeTotal,
        additionalChargeTotal,
        acChargeTotal,
        note: fresh.note,
        paymentMode: fresh.paymentMethod,

        drinkVatAmount,

        // 🔹 FIXED: Pass calculated drink tax amounts, not API values
        drinkSubtotal: drinkSubtotal,
        drinkCgst: drinkCgstAmount,
        drinkSgst: drinkSgstAmount,
        drinkTotal: drinkTotal,
      })
    } catch (error) {
      console.error('Bill print failed:', error)
      notify.error('Print Failed', error?.message || 'Failed to print bill')
    } finally {
      setPrintingBill(false)
    }
  }, [
    bill?.id,
    fetchBillForPrint,
    tableId,
    parcelChargeTotal,
    additionalChargeTotal,
    acChargeTotal,
    taxType,
    totalTaxPct,
    drinkSubtotal,
    drinkCgstAmount,
    drinkSgstAmount,
    drinkTotal,
  ])

  const handlePrintDrinkKitchen = useCallback(async () => {
    if (!bill?.id) {
      notify.error('Bill not found')
      return
    }

    if (!drinkItems.length) {
      notify.error('No drink items')
      return
    }

    setPrintingDrinkKitchen(true)

    try {
      const fresh = await fetchBillForPrint()

      const drinkOnlyItems = (fresh.items || []).filter(
        (i) => Number(i.is_drink || 0) === 1
      )

      const expandedDrinkItems = drinkOnlyItems.flatMap((item) => {
        const details =
          typeof item.drink_details === 'string'
            ? JSON.parse(item.drink_details || '{}')
            : item.drink_details || {}

        const rows = []

        const bottleQty = Number(details.bottle_qty || 0)
        if (bottleQty > 0) {
          rows.push({
            ...item,
            name: `${item.name} - Bottle`,
            qty: bottleQty,
          })
        }

        Object.entries(details.peg_qtys || {}).forEach(([pegId, qty]) => {
          const pegQty = Number(qty || 0)
          if (pegQty <= 0) return

          const peg = (details.pegs || []).find(
            (p) => String(p.id) === String(pegId)
          )

          rows.push({
            ...item,
            name: `${item.name} - ${peg?.qty || pegId}ml Peg`,
            qty: pegQty,
          })
        })

        return rows
      })
      const hotel = await getHotelConfig()

      generateBillPdf({
        type: 'kitchen',
        hotel,
        bill: fresh.bill,
        tableId,
        items: expandedDrinkItems,
        note: 'DRINK ORDER',
        paymentMode: '',
      })
    } catch (error) {
      console.error('Drink kitchen print failed:', error)
      notify.error('Print Failed', error?.message || 'Failed to print drink order')
    } finally {
      setPrintingDrinkKitchen(false)
    }
  }, [bill?.id, drinkItems, fetchBillForPrint, tableId])

  const items = localItems
  const { subtotal, total } = totals


  // Build this object (all values already computed in your component)
  const billSummary = useMemo(() => ({
    // Food
    food_subtotal: subtotal,
    food_cgst: cgstAmount,
    food_sgst: sgstAmount,
    food_discount: localDiscount,
    food_total: total,

    // Drink
    drink_subtotal: drinkSubtotal,
    drink_cgst: drinkCgstAmount,
    drink_sgst: drinkSgstAmount,
    drink_vat : drinkVatAmount,
    drink_total: drinkTotal,

    // Charges
    parcel_charge_total: parcelChargeTotal,
    additional_charge_total: additionalChargeTotal,
    ac_charge_total: acChargeTotal,

    // Grand
    grand_total: grandTotal,
  }), [
    subtotal, cgstAmount, sgstAmount, localDiscount, total,
    drinkSubtotal, drinkCgstAmount, drinkSgstAmount, drinkTotal,
    parcelChargeTotal, additionalChargeTotal, acChargeTotal,
    grandTotal,
    ])


  const columns = [
    {
      title: 'Item',
      dataIndex: 'name',
      key: 'name',
      render: (name, rec) => (
        <div className="be-item-cell">
          <span
            className="be-item-dot"
            style={{ background: (rec.is_veg ?? rec.veg) ? '#22c55e' : '#ef4444' }}
          />
          <div className="be-item-meta">
            <span className="be-item-name">{name}</span>
            {Number(rec.is_parcel || 0) === 1 && <Tag color="orange">Parcel</Tag>}
          </div>
        </div>
      ),
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      width: 90,
      render: (p) => <Text className="be-price-text">₹{Number(p).toFixed(0)}</Text>,
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      width: 150,
      render: (qty, rec) => {
        const rowKey = getItemKey(rec)
        return (
          <div className="be-table-qty-row">
            <button
              className="be-qty-btn be-minus-btn"
              onClick={() => updateQtyByRowKey(rowKey, (Number(qty) || 0) - 1)}
              disabled={!canEditItems}
              type="button"
            >
              <MinusOutlined style={{ fontSize: 9 }} />
            </button>
            <InputNumber
              min={0}
              max={50}
              value={qty || 0}
              controls={false}
              onChange={(v) => updateQtyByRowKey(rowKey, v || 0)}
              size="small"
              className="be-qty-input"
              readOnly={!canEditItems}
              disabled={!canEditItems}
            />
            <button
              className="be-qty-btn be-plus-btn"
              onClick={() => updateQtyByRowKey(rowKey, (Number(qty) || 0) + 1)}
              disabled={!canEditItems}
              type="button"
            >
              <PlusOutlined style={{ fontSize: 9 }} />
            </button>
          </div>
        )
      },
    },
    {
      title: 'CGST',
      key: 'cgst',
      width: 110,
      render: (_, rec) => (
        <Text>₹{Number(rec.item_cgst_amount || 0).toFixed(2)}</Text>
      ),
    },
    {
      title: 'SGST',
      key: 'sgst',
      width: 110,
      render: (_, rec) => (
        <Text>₹{Number(rec.item_sgst_amount || 0).toFixed(2)}</Text>
      ),
    },
    {
      title: 'Total',
      key: 'itemTotal',
      width: 120,
      render: (_, rec) => {
        const rowSub = (Number(rec.price) || 0) * (Number(rec.qty) || 0)
        const rowCgst = Number(rec.item_cgst_amount || 0)
        const rowSgst = Number(rec.item_sgst_amount || 0)

        return (
          <Text strong className="be-item-total">
            ₹{(rowSub + rowCgst + rowSgst).toFixed(2)}
          </Text>
        )
      },
    },
    {
      title: '',
      key: 'action',
      width: 50,
      render: (_, rec) => {
        const rowKey = getItemKey(rec)
        if (!canEditItems) return null
        return (
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            size="small"
            onClick={() => removeRow(rowKey)}
          />
        )
      },
    },
  ]

  return (
    <div className="bill-editor-modern">
      {!canEditItems && !canEditMeta && !canCloseBill && (
        <div
          style={{
            padding: 10,
            textAlign: 'center',
            background: '#fff1f0',
            color: '#cf1322',
            marginBottom: 10,
            borderRadius: 6,
          }}
        >
          🔒 View Only Mode – No edit permissions
        </div>
      )}

      <Card className="be-main-card" bordered={false}>
        <div className="be-toolbar">
          <div className="be-toolbar-left">
            <div className="be-toolbar-title-wrap">
              <div className="be-toolbar-icon"><ShoppingCartOutlined /></div>
              <div>
                <div className="be-toolbar-title">Bill Items</div>
                <div className="be-toolbar-subtitle">Add, update quantity, remove and split items</div>
              </div>
            </div>
          </div>

          <div className="be-toolbar-actions">
            {canEditItems && (
              <>
               {/* <Button
                  onClick={() => setDrinkPickerOpen(true)}
                  style={{ borderColor: '#f59e0b', color: '#92400e' }}
                >
                  🍷 Add Drinks
                </Button> */}

                {!isRoomServiceBill && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setPickerOpen(true)}
                    className="be-add-items-btn"
                  >
                    Add Food Items
                  </Button>
                )}

                <Button
                  icon={<InboxOutlined />}
                  onClick={() => setParcelPickerOpen(true)}
                  className="be-parcel-btn"
                >
                  Add Parcel Item
                </Button>
              </>
            )}

            {canSplitBill && items.length > 0 && (
              <Button onClick={onSplit} className="be-split-btn">Split Bill</Button>
            )}

            {syncing && (
              <div className="be-sync-indicator">
                <LoadingOutlined />
                <span>Saving</span>
              </div>
            )}
          </div>
        </div>

        {items.length === 0 ? (
          <div className="be-empty-state">
        <div className="be-empty-subtitle">Start by adding items to this bill</div>
        {canEditItems && (
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '16px' }}>
            {!isRoomServiceBill && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setPickerOpen(true)}
              >
                Add Food Item
              </Button>
            )}

            {isRoomServiceBill && (
              <Button
                type="primary"
                icon={<InboxOutlined />}
                onClick={() => setParcelPickerOpen(true)}
              >
                Add Parcel Item
              </Button>
            )}

           {/* <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setDrinkPickerOpen(true)}
            >
              Add Drink Item
            </Button>  */}
          </div>
        )}
      </div>
        ) : (
          <Table
            dataSource={items}
            columns={columns}
            rowKey={(r) => getItemKey(r)}
            pagination={false}
            size="middle"
            className="be-items-table"
            scroll={{ x: 900 }}
          />
        )}

        <DrinkBillSection
          drinkItems={drinkItems}
          onChangePeg={changeDrinkPeg}
          onChangeBottle={changeDrinkBottle}
          onRemove={removeDrinkItem}
        />
      </Card>

      <Card
        className="be-summary-card be-summary-bottom"
        bordered={false}
        title={
          <div className="be-summary-header">
            <div className="be-summary-icon"><ThunderboltOutlined /></div>
            <div>
              <div className="be-summary-title">Bill Summary</div>
              <div className="be-summary-subtitle">Quick checkout details</div>
            </div>
          </div>
        }
        extra={
          <div className="be-mini-stats">
            <div className="be-mini-stat">
              <span className="be-mini-stat-label">Items</span>
              <span className="be-mini-stat-value">{items.length}</span>
            </div>
            <div className="be-mini-stat">
              <span className="be-mini-stat-label">Qty</span>
              <span className="be-mini-stat-value">
                {items.reduce((sum, i) => sum + (Number(i.qty) || 0), 0)}
              </span>
            </div>
          </div>
        }
      >
        <div className="be-summary-block">
          <div className="be-summary-row">
            <Text className="be-summary-label">Items Subtotal</Text>
            <Text className="be-summary-value">₹{subtotal.toFixed(2)}</Text>
          </div>

          {parcelQty > 0 && Number(parcelCharge) > 0 && (
            <div className="be-summary-row">
              <Text className="be-summary-label">
                Parcel Charge ({parcelQty} qty × ₹{Number(parcelCharge).toFixed(2)})
              </Text>
              <Text className="be-summary-value">₹{parcelChargeTotal.toFixed(2)}</Text>
            </div>
          )}

          {parcelQty > 0 && Number(additionalCharge) > 0 && (
            <div className="be-summary-row">
              <Text className="be-summary-label">
                Additional Charge ({parcelQty} qty × ₹{Number(additionalCharge).toFixed(2)})
              </Text>
              <Text className="be-summary-value">₹{additionalChargeTotal.toFixed(2)}</Text>
            </div>
          )}

          {acChargeTotal > 0 && (
            <div className="be-summary-row">
              <Text className="be-summary-label">
                AC Charge ({String(table?.ac_type || '').toUpperCase()})
              </Text>
              <Text className="be-summary-value">₹{acChargeTotal.toFixed(2)}</Text>
            </div>
          )}

          <div className="be-summary-row">
            <Text className="be-summary-label">CGST ({cgstTax}%)</Text>
            <Text className="be-summary-value">₹{cgstAmount.toFixed(2)}</Text>
          </div>

          <div className="be-summary-row">
            <Text className="be-summary-label">SGST ({sgstTax}%)</Text>
            <Text className="be-summary-value">₹{sgstAmount.toFixed(2)}</Text>
          </div>

          

          <Divider className="be-divider" />

          <div className="be-summary-row">
            <Text className="be-summary-label" style={{ color: '#374151' }}>Food Total</Text>
            <Text className="be-summary-value" style={{ fontWeight: 600 }}>₹{total.toFixed(2)}</Text>
          </div>

        {/*  {drinkItems.length > 0 && (
            <>
              <Divider className="be-divider" style={{ margin: '8px 0', borderColor: '#fde68a' }} />
              <div
                style={{
                  background: '#fffbeb',
                  border: '1px solid #fde68a',
                  borderRadius: 8,
                  padding: '10px 12px',
                  margin: '4px 0 8px',
                }}
              >
                <div style={{ fontSize: 11, fontWeight: 600, color: '#92400e', marginBottom: 6 }}>
                  🍷 Wines &amp; Spirits
                </div>
                <div className="be-summary-row">
                  <Text className="be-summary-label">Drinks Subtotal</Text>
                  <Text className="be-summary-value">₹{drinkSubtotal.toFixed(2)}</Text>
                </div>
                 {drinkCgstAmount > 0 && (
                <div className="be-summary-row">
                  <Text className="be-summary-label"> Drink CGST {drinkCgstPct ? `(${drinkCgstPct}%)` : ''}</Text>
                  <Text className="be-summary-value">₹{drinkCgstAmount.toFixed(2)}</Text>
                </div>
                 )}
                
                {drinkSgstAmount > 0 && (
                <div className="be-summary-row">
                  <Text className="be-summary-label">Drink SGST {drinkSgstPct ? `(${drinkSgstPct}%)` : ''}</Text>
                  <Text className="be-summary-value">₹{drinkSgstAmount.toFixed(2)}</Text>
                </div>
                )}

                {drinkVatAmount !==0 &&(

                <div className="be-summary-row">
                  <Text className="be-summary-label">Vat ({drinkVatPct}%)</Text>
                  <Text className="be-summary-value">₹{drinkVatAmount.toFixed(2)}</Text>
                </div>
                )}

                <div className="be-summary-row" style={{ marginTop: 4 }}>
                  <Text style={{ fontWeight: 600, color: '#92400e' }}>Drinks Total</Text>
                  <Text style={{ fontWeight: 700, color: '#d97706' }}>₹{drinkTotal.toFixed(2)}</Text>
                </div>
              </div>
            </>
          )}   */}

          <div className="be-summary-row be-discount-row">
            <div className="be-discount-left">
              <Text className="be-summary-label">Discount</Text>
              <InputNumber
                min={0}
                max={Math.max(0, itemsSubtotal + parcelChargeTotal + additionalChargeTotal + acChargeTotal+drinkTotal)}
                value={localDiscount}
                onChange={(v) => saveMeta('discount', v || 0)}
                size="middle"
                prefix="₹"
                className="be-discount-input"
                disabled={!canEditMeta}
              />
            </div>
            <Text type="danger">- ₹{localDiscount.toFixed(2)}</Text>
          </div>

          <Divider className="be-divider" />
             <Text style={{ display: 'block', textAlign: 'right' }}>
              ₹{grandTotal.toFixed(2)}
            </Text>
          <div className="be-summary-row be-total-row">
            <Text strong>Grand Total</Text>
            <Text strong className="be-total-amount">₹{Math.round(grandTotal)}</Text>
          </div>
        </div>

        <div className="be-note-wrap">
          <div className="be-note-label">Bill Note</div>
          {localNote ? <div className="be-note-text">{localNote}</div> : null}
        </div>

        <div className="be-final-actions">
          <div className="be-final-actions-top">
            <Button
              className="be-kot-btn"
              onClick={handlePrintKitchen}
              disabled={items.length === 0 || printingKitchen || printingBill}
              icon={printingKitchen ? <LoadingOutlined /> : <FireOutlined />}
            >
              {printingKitchen ? 'Fetching...' : 'Kitchen Order'}
            </Button>

           {/* <Button
              style={{ borderColor: '#f59e0b', color: '#92400e' }}
              onClick={handlePrintDrinkKitchen}
              disabled={drinkItems.length === 0 || printingDrinkKitchen || printingKitchen}
              icon={printingDrinkKitchen ? <LoadingOutlined /> : '🍷'}
            >
              {printingDrinkKitchen ? 'Fetching...' : 'Drink Order'}
            </Button>  */}

            <Button
              className="be-print-btn"
              onClick={handlePrintBill}
              disabled={(items.length === 0 && drinkItems.length === 0) || printingBill || printingKitchen}
              icon={printingBill ? <LoadingOutlined /> : <PrinterOutlined />}
            >
              {printingBill ? 'Fetching...' : 'Print Bill'}
            </Button>
          </div>

          <div className="be-final-actions-bottom">
            {canCloseBill && (
              <Button
                type="primary"
                icon={<CheckCircleOutlined />}
                className="be-settle-btn"
                onClick={() => setSettleOpen(true)}
                disabled={items.length === 0 && drinkItems.length === 0}
              >
                Settle ₹{Math.round(grandTotal)}
              </Button>
            )}
          </div>
        </div>
      </Card>

      {canEditItems && (
        <ProductPickerModal
          open={pickerOpen}
          onClose={() => setPickerOpen(false)}
          onAdd={addItem}
           isDrink={false}  
          onIncrease={increaseByMenuId}
          onDecrease={decreaseByMenuId}
          existingItems={localItems.filter((i) => Number(i.is_parcel || 0) === 0)}
          menuItems={menuItems}
          categories={categories}
          canEditItems={canEditItems}
          title="Add Products to Bill"
          modeLabel="regular"
          isAcTable={isAcTable}
        />
      )}

      {canEditItems && (
        <DrinkPickerModal
          open={drinkPickerOpen}
          onClose={() => setDrinkPickerOpen(false)}
          drinkItems={drinkItems}
          onAdd={addDrinkItem}
          onChangePeg={changeDrinkPeg}
          onChangeBottle={changeDrinkBottle}
          isAcTable={isAcTable}
          isDrink={true}  
        />
      )}

      {canEditItems && (
        <ProductPickerModal
          open={parcelPickerOpen}
          onClose={() => setParcelPickerOpen(false)}
          onAdd={addParcelItem}
          onIncrease={increaseParcelByMenuId}
          onDecrease={decreaseParcelByMenuId}
          existingItems={localItems.filter((i) => Number(i.is_parcel || 0) === 1)}
          menuItems={menuItems}
          categories={categories}
          canEditItems={canEditItems}
          title="Add Parcel Items"
          modeLabel="parcel"
        />
      )}

     {canCloseBill && (
  <SettleModal
    open={settleOpen}
    onClose={() => setSettleOpen(false)}
    onSettle={(method, summary) =>
      closeBill(tableId, bill.id, method, {
        ...billSummary,
        total: grandTotal,
        grand_total: grandTotal,
      })
    }
    total={grandTotal}
    billSummary={billSummary}
  />
)}
    </div>
  )
}

export default BillEditorNoContext
